export const basePath = 'api/moderator/preferences'

export interface Item {
  id: number;
  user_id: number;
  group_id: number;
  results_per_page: number;
  send_email_on_member_messages: boolean;
  send_email_on_pending_members: boolean;
  send_email_on_pending_posts: boolean;
}

export interface ModuleState {
  items: Item[];
}
